import type { HTMLAttributes } from 'react';
import { useSiteContext, useTranslation } from '@eti/providers';
import { screenReadersOnlyStyles } from '../../utils/styleUtils';
import { getDurationDateTime, getDurationLabel } from './utils/duration-utils';

interface DurationProps extends Omit<HTMLAttributes<HTMLTimeElement>, 'aria-label' | 'dateTime'> {
  durationInMs: number;
  screenReaderTextKey?: string;
}

const TimeDuration = ({ children, durationInMs, screenReaderTextKey, ...props }: DurationProps) => {
  const { t } = useTranslation();
  const {
    language: { locale },
  } = useSiteContext();

  const dateTime = getDurationDateTime(durationInMs);
  const durationLabel = getDurationLabel(locale, durationInMs);

  return (
    <>
      <time aria-hidden="true" dateTime={dateTime} {...props}>
        <bdi>{children}</bdi>
      </time>
      <span className={screenReadersOnlyStyles}>
        {screenReaderTextKey ? t(screenReaderTextKey, durationLabel) : durationLabel}
      </span>
    </>
  );
};

export default TimeDuration;
